
import { Component, Vue, Prop, Watch, Model } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
// import { getStaKvs } from "@/api/api-basic";
import { getStaKvs } from "@/api/api-operation-service";
import { State } from "vuex-class";
@Component
export default class SelectStation extends Vue {
  @Prop({ default: 200 }) private width!: number;
  @Prop({ default: "" }) private oprPkId!: number | string;
  @Prop({ default: "" }) private merchantPkId!: number | string;
  @Prop({ default: "" }) private regionId!: number | string;
  @Prop({ default: false }) private isSelectFirst!: boolean;
  @Watch("oprPkId")
  @Watch("merchantPkId")
  @Watch("regionId")
  getVisible() {
    this.getStaKvs();
  }

  @Watch("stationId")
  getStationId() {
    if (this.stationId != this.staPkId) {
      this.staPkId = this.stationId;
    }
  }

  @Model("value", { type: String }) private stationId!: string;
  @State("sys") sys!: objAny;
  private stationList: object[] = [];

  private staPkId = "";

  async getStaKvs(): Promise<void> {
    // if (this.oprPkId == "") {
    //   this.stationList = [];
    //   this.staPkId = "";
    // } else {
    const json: objAny = {
      globalPageSize: 1000,
      globalPageIndex: 1
    };
    if (this.oprPkId && this.oprPkId != "") {
      json.oprPkId = this.oprPkId;
    }
    if (this.merchantPkId && this.merchantPkId != "") {
      json.merchantPkId = this.merchantPkId;
    }
    if (this.regionId && this.regionId != "") {
      json.regionId = this.regionId;
    }
    // if (!(this.sys.userType !== "admin" && this.oprPkId == "")) {
    const ret = await getStaKvs(json);
    if (ret.status === this.$config.apiStatus) {
      this.stationList = ret.data;
      if (this.isSelectFirst) {
        if (ret.data.length > 0) {
          this.staPkId = ret.data[0].stationPkId;
          this.$emit("value", this.staPkId);
          this.$emit("on-change", this.staPkId);
          this.$emit("on-first-change", this.staPkId);
        }
      }
    } else {
      if (this.isSelectFirst) {
        this.$emit("on-first-change", "");
      }
    }
  }

  public selectStation(val: string): void {
    val = val == undefined ? "" : val;
    this.staPkId = val;
    this.$emit("value", val);
    this.$emit("on-change", val);
  }
  mounted() {
    this.staPkId = this.stationId;
    this.getStaKvs();
  }
}
